import mischievousBanjo from '../../../../assets/svgs/actors/miriamStephanie/mischievousBanjo'

import { MISCHIEVOUS_BANJO } from '../../../../constants/scene/actors/miriamStephanie'

export default {
    [MISCHIEVOUS_BANJO]: mischievousBanjo,
}
